import React from "react";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa"; // Importando os ícones
import { useLanguage } from "../LanguageContext";
import translations from "../translations";

const About = () => {

  const { language } = useLanguage();

  return (
    <section id="about" className="h-auto flex flex-col items-center px-10 py-1">
      
      
      
      {/* Linha 1: About e Imagem lado a lado */}
      <div className="w-full flex flex-col lg:flex-row items-center justify-between mb-10">
        {/* Título "About" */}
        <div className="w-full lg:w-1/2 text-center lg:text-right mb-10 lg:mb-0">
          <h2 className="text-4xl font-extrabold text-gray-800 mb-6 relative inline-block">
            {translations[language].about}
            <span className="block w-1/2 h-1 bg-blue-500 mx-auto mt-2"></span>
          </h2>
          <p className="text-2xl font-semibold text-gray-800">{translations[language].fullName}</p>
        <p className="text-lg text-gray-700 mt-2">{translations[language].degree}</p>
        {/* Ícones de contato */}
        <div className="flex justify-center lg:justify-end items-center space-x-4 mt-4">
          <a href="mailto:marceloatj@hotmail.com" target="_blank" rel="noopener noreferrer" className="text-2xl text-gray-700 hover:text-blue-600">
            <FaEnvelope />
          </a>
          <a href="https://instagram.com/marceloatj" target="_blank" rel="noopener noreferrer" className="text-2xl text-[#E4405F] hover:text-[#C13584]">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/in/marceloatj" target="_blank" rel="noopener noreferrer" className="text-2xl text-[#0077B5] hover:text-[#005582]">
            <FaLinkedin />
          </a>
        </div>
        </div>

        <div className="w-32 h-2"></div>



        {/* Imagem */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
          <img
            src={`${process.env.PUBLIC_URL}/images/profile.jpg`}
            alt="Minha Foto"
            className="w-72 h-72 object-cover rounded-lg shadow-lg hover:scale-105 transition-all duration-300"
          />
        </div>
      </div>

      

      {/* Linha 3: Texto completo */}
      <div className="w-full text-center lg:text-left">
        <p className="text-lg text-gray-700 leading-relaxed tracking-wide">
          {translations[language].aboutText1}
        </p>

        <p className="mt-4 text-lg text-gray-700 leading-relaxed tracking-wide">
        {translations[language].aboutText2}
        </p>

        <p className="mt-4 text-lg text-gray-700 leading-relaxed tracking-wide">
        {translations[language].aboutText3}
        </p>

        <p className="mt-4 text-lg text-gray-700 leading-relaxed tracking-wide">
        {translations[language].aboutText4}
        </p>

        <p className="mt-4 text-lg text-gray-700 leading-relaxed tracking-wide">
        {translations[language].aboutText5}
        </p>
      </div>
    </section>
  );
};

export default About;